
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {Options, Vue} from 'vue-property-decorator';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';

    @Options({})
    export default class ExpertiseSide extends Vue {
        tipsPart: TipsPart | null = null; // with null, tipsPart is a reactive value
        tipsClassPosition = getTipsClassPosition(85);

        created(): void {
            this.tipsPart = this.defaultTips;
            this.bottomSheetDisplayer = new BottomSheetDisplayer('', '', this.$el, 'div.profile-creation-wizard');
            eventBusProfileCreationWizard.on('creation:focus-changed', this.listenFocus);
        }

        mounted(): void {
            this.bottomSheetDisplayer.mounted();
        }

        beforeUnmount(): void {
            eventBusProfileCreationWizard.off('creation:focus-changed', this.listenFocus);
        }

        listenFocus(tipsPart: TipsPart): void {
            if (tipsPart === TipsPart.tags) {
                this.tipsClassPosition = getTipsClassPosition(85);
            } else {
                this.tipsClassPosition = getTipsClassPosition(400);
            }
            this.tipsPart = tipsPart;
        }

        get defaultTips(): TipsPart {
            return TipsPart.tags;
        }

        get isTagsFocus(): boolean {
            return this.tipsPart === TipsPart.tags;
        }

        get isPriceFocus(): boolean {
            return this.tipsPart === TipsPart.price;
        }
    }
